/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { Text } from '@veeam/components';

import { BlankLine } from '../BlankLine';
import { ParagraphDivider } from '../ParagraphDivider';
import { TextDividerSymbols } from '../../../../helpers/text-parser';

export interface TextFromSimpleConfigProps {
    simpleConfig: string[];
}

export const TextFromSimpleConfig: React.FC<TextFromSimpleConfigProps> = ({ simpleConfig }) => {
    const textOrConfigContent: React.ReactElement<void>[] = (simpleConfig).map((msg: string, index: number): React.ReactElement<void> => {
        if (msg === TextDividerSymbols.BlankLine) {
            return <BlankLine key={`${msg}-${index}`} />;
        } else if (msg === TextDividerSymbols.Paragraph) {
            return <ParagraphDivider key={`${msg}-${index}`} />;
        }

        return <Text key={`${msg}-${index}`}>{msg}</Text>;
    });

    return <Text>{textOrConfigContent}</Text>;
};
